import { Link } from "gatsby";
import React from "react";
import Markdown from "react-markdown";
import { ebola_form_url } from "../../../utils/url-provider";
import { getClickIdByTitle } from "../../../utils/ebolaClickIdProvider";

const OverViewWithCta = ({ data }) => {
  if (!data) {
    return null;
  }
  return (
    <div className="container text-center lg:pt-[1vw] pt-[1.5vw] lg:px-[1vw] px-[2vw] text-primary">
      {data?.description?.data?.description && (
        <div>
          {data?.description?.data?.description
            ?.split("\n")
            .map((line, index) => (
              <div
                key={index}
                className="font-redhatRegular lg:text-[1.25vw] md:text-[3.6vw] text-[4vw] leading-tight"
              >
                <Markdown>{line}</Markdown>
              </div>
            ))}
        </div>
      )}
      <div className="lg:flex justify-center items-center lg:gap-x-[0.5vw] lg:py-[1vw] py-[3vw]">
        <p className="font-redhatMedium lg:pb-0 pb-[2vw] lg:text-[1.25vw] md:text-[3.6vw] text-[4vw] leading-tight">
          To fill the self-declaration form
        </p>
        <Link to={ebola_form_url} target="_blank">
          <button
          id={getClickIdByTitle("Submit Self-Declaration Form")}
          className="font-redhatMedium lg:rounded-[0.5vw] rounded-[1vw] bg-primary text-white lg:px-[1vw] px-[4vw] lg:py-[0.5vw] py-[1.5vw] lg:text-[1.25vw] md:text-[3.6vw] text-[4vw]">
            Submit Self-Declaration Form
          </button>
        </Link>
      </div>
    </div>
  );
};

export default OverViewWithCta;
